import { yupResolver } from "@hookform/resolvers/yup";
import {
  toastrErrorAlert,
  toastrSuccessAlert,
} from "components/Common/AlertToastr";
import { CommonButton } from "components/Common/ButtonCommon";
import HeaderCreateItem from "components/Common/HeaderCreateItem";
import useGetFormSchema from "custom-hook/useGetFormSchema";
import { uploadImg } from "helpers/erp_helper";
import { GET_PHL_PRODUCT } from "helpers/url_helper";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import httpService from "services/httpService";
import * as yup from "yup";

export default function NewPHLProduct() {
  const { id } = useParams();
  const history = useHistory();
  const [image, setImage] = useState([]);

  const { state } = useLocation();

  const schema = yup
    .object({
      product: yup
        .object()
        .nullable()
        .transform((_, val) =>
          val.text
            ? {
                __type: "Pointer",
                className: "Product",
                objectId: val.objectId,
              }
            : null
        ),
      order: yup.string().required("Vui lòng nhập số thứ tự hiển thị!"),
    })
    .required();

  useEffect(() => {
    getPHLProductDetail();
  }, [id]);

  useEffect(() => {
    rest.setValue(
      "product",
      state?.productId
        ? {
            text: state?.productName,
            objectId: state?.productId,
            className: "Product",
            __type: "Pointer",
          }
        : { text: "" }
    );
  }, [state]);

  const {
    handleSubmit,
    formState: { errors },
    ...rest
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const { renderForm, content, images, getContent } = useGetFormSchema(
    "ProductContent",
    yup,
    rest,
    errors
  );

  const getPHLProductDetail = async () => {
    if (!id) return;

    const res = await httpService.get(
      `${GET_PHL_PRODUCT}/${id}?include="product"`
    );

    if (!res) {
      history.replace("/product-content");
      toastrErrorAlert("Product content not found!");
      return;
    }
    const { reset } = rest;

    setImage({
      ...res.image,
      url: res?.image?.url.replace("phl.vvs.vn", "phl.live1.vn"),
    });
    reset({
      ...res,
      product: res?.product
        ? {
            text: res.product.name,
            objectId: res.product.objectId,
            className: "Product",
            __type: "Pointer",
          }
        : { text: "" },
      image: {
        ...res.image,
        url: res.image?.url.replace("phl.vvs.vn", "phl.live1.vn"),
      },
    });

    getContent({ content: res.htmlText });
  };

  const onSubmit = async values => {
    const { createdAt, updatedAt, product, ...rest } = values;

    const thumbnail = await uploadImg(rest.image);

    const newPhlProduct = {
      order: Number(rest.order),
      ...(!rest.image?.__type && { image: thumbnail }),
      ...(rest.image?.isRemove && {
        image: { __op: "Delete" },
      }),
      htmlText: content,
      ...(product !== null
        ? {
            product: {
              __type: "Pointer",
              className: "Product",
              objectId: product.objectId,
            },
          }
        : { product: { __op: "Delete" } }),
    };

    if (id) {
      await httpService.put(`${GET_PHL_PRODUCT}/${id}`, newPhlProduct);
      toastrSuccessAlert("Cập nhật chi tiết sản phẩm thành công!");
      return;
    }

    const res = await httpService.post(`${GET_PHL_PRODUCT}`, newPhlProduct);

    toastrSuccessAlert("Thêm chi tiết sản phẩm thành công!");
    history.replace(`/product-content/${res.objectId}`);
  };

  const includeProps = {
    product: {
      disabled: Boolean(state?.productId),
    },
  };

  return (
    <div className="page-content">
      <form onSubmit={handleSubmit(onSubmit)}>
        <HeaderCreateItem title={"Sản phẩm PHL"}>
          <CommonButton level={0} type="submit">
            Save
          </CommonButton>
        </HeaderCreateItem>
        <Container fluid>{renderForm([], includeProps)}</Container>
      </form>
    </div>
  );
}
